import { Accordion, Typography } from "@aph/ui-lib-humanx";
import React, { useState } from "react";
import styles from "@/components/FAQ/faq.module.scss";
import { FAQComponent as FAQComponentType, FAQItem } from "@/components/FAQ/interface";
import QuestionAnswers from "@/components/QuestionAnswers";

interface FAQComponentProps {
  data: FAQComponentType;
}

const FAQComponent: React.FC<FAQComponentProps> = (props) => {
  const { data } = props;
  const { FAQList, Title } = data;
  const [activeCategory, setActiveCategory] = useState<string>(FAQList?.[0]?.Category?.data?.attributes?.CategoryName);

  const handleTabChange: (slug: string) => void = (slug) => {
    setActiveCategory(slug);
  };

  const getFaqCategory = () => {
    const categories = [];
    FAQList.map((data: FAQItem) => {
      if (
        data?.Category?.data?.attributes?.CategoryName &&
        categories.indexOf(data?.Category?.data?.attributes?.CategoryName) === -1
      ) {
        categories.push(data?.Category?.data?.attributes?.CategoryName);
      }
    });

    return categories;
  };

  const categories = getFaqCategory();

  const getAccordionPanel = () => {
    let faqList = [...FAQList];
    const accordionPanel = [];

    if (activeCategory) {
      faqList = FAQList?.filter((data) => data?.Category?.data?.attributes?.CategoryName === activeCategory);
    }

    faqList.map(({ Title, QAList }: FAQItem) => {
      accordionPanel.push({
        title: Title,
        isComponent: true,
        description: <QuestionAnswers qaList={QAList} />,
      });
    });

    return accordionPanel;
  };

  const panels = getAccordionPanel();

  const faqSchema = () => {
    const faqs = [];
    FAQList.forEach((data) => {
      faqs.push(...data.QAList);
    });
    const mainEntity =
      faqs?.length > 0 &&
      faqs.map((faq: any) => {
        return {
          "@type": "Question",
          name: faq.Question,
          acceptedAnswer: {
            "@type": "Answer",
            text: faq.Answer,
          },
        };
      });

    return mainEntity || [];
  };

  return (
    <>
      <script
        className="structured-data-list"
        type="application/ld+json"
        key={"faqSchema"}
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: faqSchema(),
          }),
        }}
      ></script>
      <div className={styles.faqRoot}>
        <div className="container">
          {Title && (
            <Typography component="h2" className={styles.title}>
              <div dangerouslySetInnerHTML={{ __html: Title }} />
            </Typography>
          )}

          {categories?.length > 0 && (
            <div className={styles.tabsWrapper}>
              {categories.map((CategoryName) => {
                const isActive = activeCategory === CategoryName;

                return (
                  <button
                    type={"button"}
                    onClick={() => handleTabChange(CategoryName)}
                    key={CategoryName}
                    className={`${styles.tab} ${isActive ? styles.active : ""}`}
                  >
                    {CategoryName}
                  </button>
                );
              })}
            </div>
          )}

          <Accordion
            panels={panels}
            defaultOpen={false}
            defaultFirstOpen
            name="accordionCommon"
            className={styles.faqSction}
          />
        </div>
      </div>
    </>
  );
};

export default FAQComponent;
